import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';

import ToggleFilter from 'components/Filters/ToggleFilter';

import './styles.css';

interface PassedProps {
  setFilter: (field: string) => void;
  clearFilters: () => void;
  getFilters: any;
}

class UserListFilters extends React.Component<PassedProps> {
  clearFilters = () => {
    this.props.clearFilters();
  };

  render() {
    const {setFilter} = this.props;

    const filters: any = this.props.getFilters();

    return (
      <div className="UserListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <ToggleFilter
            label="Is Member"
            value={filters.isMember}
            onChange={() => setFilter('isMember')}
          />
          <ToggleFilter
            label="Is Admin"
            value={filters.isAdmin}
            onChange={() => setFilter('isAdmin')}
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default UserListFilters;
